console.log("[SkAuth main] file loaded");

import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./sk-auth-init"; // Инициализация глобальных обработчиков

// Функция для получения или создания корневого элемента
function getRootContainer() {
	// Пытаемся найти существующий контейнер
	let rootEl = document.getElementById("sk-auth-root");
	if (rootEl) {
		return rootEl;
	}

	// Если контейнер не найден (режим интеграции), создаём свой
	rootEl = document.createElement("div");
	rootEl.id = "sk-auth-root";

	// Стили, чтобы контейнер не влиял на вёрстку
	Object.assign(rootEl.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "0",
		height: "0",
		overflow: "visible",
		zIndex: "9999",
	});

	// ⚠️ здесь раньше падало, если body ещё нет
	if (document.body) {
		document.body.appendChild(rootEl);
	} else {
		console.error("[SkAuth main] document.body is null");
	}

	return rootEl;
}

// Функция монтирования React-приложения
function mountApp() {
	console.log("[SkAuth main] mountApp called");

	const container = getRootContainer();
	// console.log("[SkAuth main] container:", container);

	const root = ReactDOM.createRoot(container);

	// console.log("[SkAuth main] before render");

	root.render(
		<React.StrictMode>
			<AuthProvider>
				<App />
			</AuthProvider>
		</React.StrictMode>,
	);

	// console.log("[SkAuth main] after render");
}

// Ждём готовности DOM (критично для Bitrix)
if (document.readyState === "loading") {
	console.log("[SkAuth main] waiting DOMContentLoaded");
	document.addEventListener("DOMContentLoaded", mountApp);
} else {
	console.log("[SkAuth main] DOM already ready");
	mountApp();
}
